module.exports = __webpack_public_path__ + "img/pack.1e6c5ac9.png";